export default "__VITE_ASSET__C2hgQ0Dg__"